import type { SVGProps } from 'react';

const SvgTextListBullet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M5.29 5.29A1 1 0 0 0 5 6c0 .27.11.52.29.71.19.19.44.29.71.29s.52-.11.71-.29A1 1 0 0 0 7 6c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0zm0 12A1 1 0 0 0 5 18c0 .27.11.52.29.71s.44.29.71.29.52-.11.71-.29A1 1 0 0 0 7 18c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0zm0-6A1 1 0 0 0 5 12c0 .27.11.52.29.71.19.19.44.29.71.29s.52-.11.71-.29q.075-.075.12-.15c.04-.05.07-.11.09-.17.03-.06.05-.12.06-.19.01-.06.02-.13.02-.2 0-.26-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0zM10 7h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1m8 10h-8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1m0-6h-8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgTextListBullet;
